import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import type { FooterResult } from '../../data/FooterFragment'
import type { SocialResult } from '../../data/SocialFragment'
import { FooterMessageForm } from '../form/FooterMessageForm'
import { FooterNewsletterForm } from '../form/FooterNewsletterForm'
import { Container } from '../shared/Container'
import { SocialRow } from '../shared/SocialRow'
import style from './Footer.module.sass'
import { FooterColumn } from './FooterColumn'
import { FooterPath } from './FooterPath'

type FooterProps = {
	isCompact?: boolean
	footer: FooterResult
	socials: SocialResult[]
}

export const Footer: FunctionComponent<FooterProps> = ({ isCompact = false, footer, socials }) => {
	const translate = useTranslate()
	return (
		<footer className={clsx(style.footer, isCompact && style.footerSmall)}>
			<Container size="wide">
				{isCompact ? (
					<FooterPath aloneStanding footer={footer} />
				) : (
					<>
						<div className={style.body}>
							<FooterColumn title={translate('footer.column.first.title')} content={<FooterMessageForm />} />
							<FooterColumn title={translate('footer.column.second.title')} content={<FooterNewsletterForm />} />
							<FooterColumn
								title={translate('footer.column.third.join.title')}
								content={<SocialRow socials={socials} isAlignedLeft />}
							/>
						</div>
						<FooterPath footer={footer} />
					</>
				)}
			</Container>
		</footer>
	)
}
